function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, React.createElement("g", null, React.createElement("path", {
  d: "M17.5,34 C26.6126984,34 34,26.6126984 34,17.5 C34,8.38730163 26.6126984,1 17.5,1 C8.38730163,1 1,8.38730163 1,17.5 C1,26.6126984 8.38730163,34 17.5,34 Z M12.5833333,11.2 C12.5833333,10.0954305 13.4787638,9.2 14.5833333,9.2 C15.6879028,9.2 16.5833333,10.0954305 16.5833333,11.2 L16.5833333,23.7406165 C16.5833333,24.845186 15.6879028,25.7406165 14.5833333,25.7406165 C13.4787638,25.7406165 12.5833333,24.845186 12.5833333,23.7406165 L12.5833333,11.2 Z M18.4166667,11.2 C18.4166667,10.0954305 19.3120972,9.2 20.4166667,9.2 C21.5212362,9.2 22.4166667,10.0954305 22.4166667,11.2 L22.4166667,23.7406165 C22.4166667,24.845186 21.5212362,25.7406165 20.4166667,25.7406165 C19.3120972,25.7406165 18.4166667,24.845186 18.4166667,23.7406165 L18.4166667,11.2 Z"
}))));

const SvgPauseHoverIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgPauseHoverIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause-hover-icon.129a69b1.svg";
export { ForwardRef as ReactComponent };